/* eslint-disable no-nested-ternary */
// Dependecies
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import 'antd/dist/antd.css';
import { withTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { DatePicker, TimePicker } from 'antd';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// Component
import Template from '../../components/Template';
import RenderTooltip from '../../components/RenderTooltip';
import Reload from '../../components/Reload';
import PopUp from '../../components/Modal';
import Successfully from '../../components/Successfully';

// Hooks
import useJobRequest from '../../hooks/useJobRequest';
import useNotificationRead from '../../hooks/useNotificationRead';
import useCity from '../../hooks/useCities';

// Images
import infoAlert from '../../../sass/images/alert/info-alert.svg';
import alert from '../../../sass/images/alert/alert.svg';
import calendarIcon from '../../../sass/images/icons/calendar-day.svg';
import clockIcon from '../../../sass/images/icons/clock.svg';
import info from '../../../sass/images/icons/interrogante.svg';
import uploadFile from '../../../sass/images/icons/upload-file.svg';
import errorAlert from '../../../sass/images/alert/icon-error-alert.svg';
import alertIcon from '../../../sass/images/icons/modal-alert.svg';
import img from '../../../sass/images/icons/right-check.svg';
import notPlan from '../../../sass/images/company/not-plan.svg';

// Utils
import { contactEmail, contacNumber } from '../../helpers';

const GARAGE_CAR = 'carro taller';

function JobRequest(props) {
  const { cities } = useCity();
  const { t } = props;
  const { register, handleSubmit, errors, watch, reset, defaultValues } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUnregister: true,
  });
  const {
    itemTypeService,
    messageError,
    messageAlert,
    onSubmit,
    OnFile,
    file,
    disabledDate,
    isCompleted,
    setIsCompleted,
    setIsCompleted1,
    isCompleted2,
    setIsCompleted2,
    isCompleted3,
    setIsCompleted3,
    setIsCompleted4,
    isCompleted5,
    setIsCompleted5,
    isCompleted6,
    setIsCompleted6,
    packagesCompany,
    fileName,
    validateFile,
    openModalError,
    closeModal,
    send,
    successfully,
    setSuccessfully,
    searchLicensePlate,
    setLicensePlates,
    licensePlates,
    openModalErrorVehicle,
    request,
    onPanelChange,
    usersCompanies,
    dateCalendar,
    errorFile,
    onSelect,
    selectedTime,
    ontypeService,
    garageEnableds,
    valType,
    useSetGaragaCar,
    garagaCar,
    descriptionService,
    userVehicle,
    useSetUserVehicle,
    cityService,
    useSetCityService,
    successSubmit,
    openModalErrorPlan,
    requestPlan,
  } = useJobRequest(
    reset,
    defaultValues,
    t('routers:VehicleRegistration'),
    t('routers:PlansCompany'),
    watch
  );
  const { newMaintenancesCompany } = useNotificationRead();
  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="maintenance"
      className="container_menu maintenance"
    >
      <>
        {openModalError ? (
          <PopUp
            open={openModalError}
            close={closeModal}
            icon={alertIcon}
            title={t('title-modal')}
            description={t('description-modal')}
            back={t('cancel')}
            go={t('send-btn')}
            accept={send}
            modalDesign
            btnAccept
            btnClose={false}
            classNameContent="modal-confirm error"
            classNameBtn="btn_modal pink job-requests"
          />
        ) : (
          ''
        )}
        {openModalErrorVehicle ? (
          <PopUp
            open={openModalErrorVehicle}
            close={closeModal}
            icon={alertIcon}
            title={t('tittle-modal')}
            description={t('question-modal')}
            back={t('cancel')}
            go={t('button-modal')}
            accept={request}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm error"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}
        {openModalErrorPlan ? (
          <PopUp
            open={openModalErrorPlan}
            close={closeModal}
            icon={alertIcon}
            title={t('tittle-modal-plan')}
            description=""
            back={t('cancel')}
            go={t('button-modal-plan')}
            accept={requestPlan}
            modalDesign
            btnAccept
            btnClose
            classNameContent="modal-confirm error"
            classNameBtn="btn_modal pink"
          />
        ) : (
          ''
        )}

        {!packagesCompany ? (
          <Reload
            number={!packagesCompany ? 0 : -1}
            title={t('title')}
            text={t('alert:reload')}
            img={notPlan}
            firstTxt={t('alert:first-txt')}
            secondTxt={t('alert:second-txt')}
            link={t('routers:PlansCompany')}
            linkTxt={t('alert:link-txt')}
          />
        ) : successfully ? (
          <Successfully
            img={img}
            t={t}
            setAlert={setSuccessfully}
            txt1={t('txt-successfully')}
            txt2={t('txt-2-successfully')}
            txt3={t('txt-3-successfully')}
            src={t('routers:JobsAgenda')}
          />
        ) : (
          <div className="content_dynamic history block-job-requests">
            <Row className="content_maintenace">
              <div className="header-content">
                <div className="info-tittle">
                  <h1 className="title-maintenances">{t('title')}</h1>
                  <p>{t('description')}</p>
                </div>
              </div>
            </Row>
            <div className="block-form">
              <form key={1} onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
                <Row className="no-gutters">
                  <Col xs={12} sm={12} md={4} className="block-job">
                    <label
                      htmlFor="plate"
                      className={`col-form-label ${errors.plate ? 'error_label' : ''}`}
                    >
                      {t('plate')}
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="plate"
                      id="plate"
                      defaultValue={licensePlates || ''}
                      ref={register({
                        required: {
                          value: true,
                          message: t('required'),
                        },
                        maxLength: {
                          value: 6,
                          message: t('max-6'),
                        },
                        minLength: {
                          value: 3,
                          message: t('min-3'),
                        },
                        pattern: {
                          value: /[a-zA-Z0-9]$/i,
                          message: t('char-esp'),
                        },
                      })}
                      onBlur={() => {
                        searchLicensePlate();
                        ontypeService();
                      }}
                      onChange={(e) => {
                        setIsCompleted(e.target.value.length > 0);
                        setLicensePlates(e.target.value.toUpperCase());
                      }}
                    />

                    {errors.plate && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:tooltip')} />
                          {errors.plate.message}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job">
                    <label
                      htmlFor="date"
                      className={`col-form-label ${errors.date ? 'error_label' : ''}`}
                    >
                      {t('date')}
                    </label>

                    <DatePicker
                      showToday
                      disabledDate={disabledDate}
                      className="form-control"
                      value={dateCalendar}
                      defaultValue={dateCalendar}
                      selected={dateCalendar}
                      popupClassName="date-job-request"
                      suffixIcon={<img src={calendarIcon} alt={t('alt:calendar')} />}
                      placeholder=""
                      onChange={onPanelChange}
                      allowClear={false}
                    />
                    {errors.date && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.date.message}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job">
                    <label
                      htmlFor="hours"
                      className={`col-form-label ${errors.hours ? 'error_label' : ''}`}
                    >
                      *{t('hour-maintenance')}
                    </label>
                    <TimePicker
                      className="form-control"
                      onSelect={onSelect}
                      format="h:mm a"
                      defaultValue={selectedTime}
                      value={selectedTime}
                      suffixIcon={<img src={clockIcon} alt={t('alt:calendar')} />}
                      use12Hours
                      showNow
                      inputReadOnly
                      minuteStep={10}
                      allowClear={false}
                    />
                    {errors.hours && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.hours.message}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job">
                    <label
                      htmlFor="userCompany"
                      className={`col-form-label ${errors.userCompany ? 'error_label' : ''}`}
                    >
                      *{t('name')}
                    </label>
                    <select
                      defaultValue={userVehicle}
                      className="form-control"
                      id="userCompany"
                      name="userCompany"
                      ref={register({
                        required: {
                          value: true,
                          message: t('required'),
                        },
                      })}
                      onChange={(e) => {
                        setIsCompleted2(e.target.value.length > 0);
                        useSetUserVehicle(e.target.value);
                      }}
                    >
                      <option value="" disabled>
                        {t('select')}
                      </option>
                      {usersCompanies.map((usersCompany) => (
                        <option value={usersCompany.id} key={usersCompany.id}>
                          {usersCompany.name} {usersCompany.last_name}
                        </option>
                      ))}
                    </select>
                    {errors.userCompany && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.userCompany.message}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} md={4} className="block-job">
                    <label
                      htmlFor="city"
                      className={`col-form-label ${errors.city ? 'error_label' : ''}`}
                    >
                      *{t('city_name')}
                    </label>
                    <select
                      defaultValue={cityService}
                      className="form-control"
                      id="city"
                      name="city"
                      ref={register({
                        required: {
                          value: true,
                          message: t('required'),
                        },
                      })}
                      onChange={(e) => {
                        setIsCompleted3(e.target.value.length > 0);
                        ontypeService();
                        useSetCityService(e.target.value);
                      }}
                    >
                      <option value="" disabled>
                        {t('select')}
                      </option>
                      {cities.map((city) => (
                        <option value={city.id} key={city.id}>
                          {city.name}
                        </option>
                      ))}
                    </select>
                    {errors.city && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.city.message}
                        </p>
                      </div>
                    )}
                  </Col>
                  {garagaCar === GARAGE_CAR ? (
                    <Col xs={12} sm={12} md={4} className="block-job">
                      <label
                        htmlFor="address"
                        className={`col-form-label ${errors.address ? 'error_label' : ''}`}
                      >
                        *{t('address')}
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="address"
                        ref={register({
                          required: {
                            value: true,
                            message: t('required'),
                          },
                          maxLength: {
                            value: 80,
                            message: t('max-80'),
                          },
                          minLength: {
                            value: 10,
                            message: t('min-10'),
                          },
                        })}
                        onChange={(e) => {
                          setIsCompleted1(e.target.value.length > 0);
                        }}
                      />

                      {errors.address && (
                        <div className="error_input">
                          <p>
                            <img src={alert} alt={t('alt:tooltip')} />
                            {errors.address.message}
                          </p>
                        </div>
                      )}
                    </Col>
                  ) : (
                    ''
                  )}
                </Row>
                <Row className="no-gutters block-items">
                  <Col sm={12}>
                    <label
                      htmlFor="sistem"
                      className={`col-form-label ${errors.plate ? 'error_label' : ''}`}
                    >
                      {t('type')}
                    </label>
                    <div className="row no-gutters checks">
                      {itemTypeService.map((itemsistem, index) => (
                        <div className="col-12 col-md-4 col-lg-3" key={itemsistem.id}>
                          <div className="box_checkbox">
                            {itemsistem.checked ? (
                              <input
                                id={`sistem${itemsistem.id}`}
                                name={`sistems[${index}].id`}
                                type="checkbox"
                                value={itemsistem.id}
                                ref={register()}
                                defaultChecked
                                onChange={(e) => {
                                  setIsCompleted4(e.target.checked);
                                  ontypeService();
                                }}
                              />
                            ) : (
                              <input
                                id={`sistem${itemsistem.id}`}
                                name={`sistems[${index}].id`}
                                type="checkbox"
                                value={itemsistem.id}
                                ref={register()}
                                defaultChecked={false}
                                onChange={(e) => {
                                  setIsCompleted4(e.target.checked);
                                  ontypeService();
                                }}
                              />
                            )}
                            <label htmlFor={`sistem${itemsistem.id}`} className="check">
                              {itemsistem.name}
                            </label>
                            <OverlayTrigger
                              placement="top"
                              className="tooltip-info"
                              delay={{ show: 50, hide: 500 }}
                              overlay={(componentProps) =>
                                RenderTooltip({
                                  ...componentProps,
                                  text: itemsistem.description,
                                  unique: true,
                                  src: '',
                                  id: 'tooltip-info',
                                  classtxt: 'tooltip_txt_job',
                                })
                              }
                            >
                              <img className="info-job-request" src={info} alt={t('alt:tooltip')} />
                            </OverlayTrigger>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
                <Row className="no-gutters">
                  <Col xs={12} sm={12} md={12}>
                    <label
                      htmlFor="name"
                      className={`col-form-label ${errors.description ? 'error_label' : ''}`}
                    >
                      {t('description-service')}
                    </label>
                    <input
                      defaultValue={descriptionService || ''}
                      className="form-control"
                      type="text"
                      name="description"
                      placeholder={t('placeholder-description')}
                      ref={register({
                        required: {
                          value: true,
                          message: t('required'),
                        },
                        maxLength: {
                          value: 500,
                          message: t('max-600'),
                        },
                        minLength: {
                          value: 3,
                          message: t('min-3'),
                        },
                      })}
                      onChange={(e) => {
                        setIsCompleted5(e.target.value.length > 0);
                      }}
                    />

                    {errors.description && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.description.message}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col className="block-job upload" xs={12} sm={12} md={6}>
                    <label
                      htmlFor="name"
                      className={`col-form-label ${errors.image ? 'error_label' : ''}`}
                    >
                      {t('image')}
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      accept="image/png, image/jpg, image/jpeg, application/pdf"
                      id="file"
                      name="image"
                      onChange={(e) => OnFile(e)}
                      ref={
                        (React.createRef(),
                        register({
                          required: { value: false, message: t('required') },
                          setValueAs: file,
                        }))
                      }
                    />
                    <p className={fileName ? 'name-img' : 'name-img placeholder-img'}>
                      {fileName || t('load_image')}
                    </p>
                    <div id="uploadImage" border="1" width="150" height="150">
                      <img className="image-job-request" src={uploadFile} alt={t('alt:download')} />
                    </div>

                    {errorFile ? (
                      !validateFile ? (
                        <div className="error_input">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {t('required-image')}
                          </p>
                        </div>
                      ) : (
                        <div className="error_input">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {t('required-image-size')}
                          </p>
                        </div>
                      )
                    ) : (
                      ''
                    )}
                  </Col>
                  {isCompleted && isCompleted2 && isCompleted3 && valType && isCompleted5 ? (
                    <Col xs={12} sm={12} md={6} className="block-job">
                      <label
                        htmlFor="workshop"
                        className={`col-form-label ${errors.workshop ? 'error_label' : ''}`}
                      >
                        *{t('garage')}
                      </label>
                      <select
                        defaultValue=""
                        className="form-control"
                        id="workshop"
                        name="workshop"
                        ref={register({
                          required: {
                            value: true,
                            message: t('required'),
                          },
                        })}
                        onChange={(e) => {
                          setIsCompleted6(e.target.value.length > 0);
                          useSetGaragaCar(
                            e.target.options[e.target.selectedIndex].getAttribute('class')
                          );
                        }}
                      >
                        {garageEnableds.length > 0 ? (
                          <>
                            <option value="" disabled>
                              {t('select')}
                            </option>
                            {garageEnableds.map((garageEnabled) => (
                              <option
                                value={garageEnabled.id}
                                key={garageEnabled.id}
                                className={garageEnabled.garage_car ? GARAGE_CAR : ''}
                              >
                                {garageEnabled.name} - {garageEnabled.address}
                              </option>
                            ))}
                            ;
                          </>
                        ) : (
                          <option value="" disabled>
                            {t('error_garage')}
                          </option>
                        )}
                      </select>

                      {errors.workshop && (
                        <div className="error_input">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {errors.workshop.message}
                          </p>
                        </div>
                      )}
                    </Col>
                  ) : (
                    ''
                  )}
                  <div className="input-required">
                    <p>{t('field-required')}</p>
                  </div>
                </Row>
                <div className="block-button">
                  <button
                    id="BtnSubmit"
                    type="submit"
                    disabled={
                      !(
                        isCompleted &&
                        isCompleted2 &&
                        isCompleted3 &&
                        valType &&
                        isCompleted5 &&
                        isCompleted6
                      ) || successSubmit
                    }
                    className={` btn btn-primary button-job ${
                      isCompleted &&
                      isCompleted2 &&
                      isCompleted3 &&
                      valType &&
                      isCompleted5 &&
                      isCompleted6
                        ? 'send_register register orange'
                        : 'send_register register grey'
                    } `}
                  >
                    {t('send')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {messageAlert && (
          <Alert variant="warning">
            <Alert.Heading>
              <img src={infoAlert} alt={t('alt:notification')} />
              <strong>{t('alert:title-info-contact')}</strong>
            </Alert.Heading>
            <p>
              {t('alert:info-contactCompany')} {contacNumber()} {t('alert:info-contact2')}
              <strong> {contactEmail()} </strong>
            </p>
          </Alert>
        )}

        {messageError && (
          <Alert variant="danger" className="alert-response">
            <img src={errorAlert} alt={t('alt:errorAlert')} />
            <p>{t('alert:error')}</p>
          </Alert>
        )}
      </>
    </Template>
  );
}

JobRequest.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['jobRequest', 'alert', 'alt', 'routers', 'register'])(JobRequest);
